import type { MobileRedirectStepValues } from '../constants';

import { useState } from 'react';

import { MobileRedirectStep } from '../constants';

export function useMobileRedirectStep() {
  const [step, setStep] = useState<MobileRedirectStepValues>(MobileRedirectStep.SCAN);

  return {
    step,
    setStep,
    MobileRedirectStep,
  };
}
